import clsx from "clsx";
import styles from "./CountBadge.module.scss";

export interface CountBadgeProps {
  /** How many items the card lists. */
  count: number;
  className?: string;
}

/**
 * The black count dot in a card's head, top right — "how many are in this list". One component because the
 * dashboard's Opportunities and To-do cards each carried their own copy of it, and the release checklist wrote the
 * count as a sentence instead ("Tasks 7 tasks"); the same fact should look the same on every card.
 */
export function CountBadge({ count, className }: CountBadgeProps) {
  return (
    <span className={clsx(styles.badge, className)}>
      {count}
    </span>
  );
}
